<template>
  <div class="article_ui">
      <el-image  :src="src" fit="contain"></el-image>
  </div>
</template>

<script>

import moment from 'dayjs'

export default {
  components: {
  
  },
  data() {
    return {
      extra:'',
      src:'assets/img1.png'
    };
  },
  created() {
    this.extra=this.$route.query.extra
    if(this.extra==18){
      this.src='assets/img1.png'
    }
    if(this.extra==6){
      this.src='assets/img2.png'
    }
    if(this.extra==17){
      this.src='assets/img3.png'
    }
  },
  computed: {
    
  },
  methods: {
    
  }
};
</script>

<style lang="less" scoped>
.article_ui{
  width: 100%;
  height: auto;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 4px 0px rgba(235, 235, 235, 0.5);
  
  box-sizing: border-box;
  .el-image{
    width:100%;
  }
  
}
</style>
